import { CHATBOT_LAUNCHER_ID } from "./redux/chatBotSlice";

// Timing/easing for the widget's fly-to/from-navbar animation.
export const DOCK_ANIM_MS = 720;
const DOCK_EASING = "cubic-bezier(0.22, 0.61, 0.36, 1)";
export const DOCK_TRANSITION = `transform ${DOCK_ANIM_MS}ms ${DOCK_EASING}, opacity ${DOCK_ANIM_MS}ms ${DOCK_EASING}`;

// Approximate top-right navbar spot, used only when the launcher can't be located.
function fallbackLauncherRect() {
  return { left: window.innerWidth - 60, top: 16, width: 44, height: 44 };
}

function toRect({ left, top, width, height }) {
  return { left, top, width, height };
}

// Locate the navbar launcher: live DOM first, then the last stored rect, then a fallback.
export function resolveLauncherRect(storedRect) {
  const el = document.getElementById(CHATBOT_LAUNCHER_ID);
  if (el) {
    const rect = el.getBoundingClientRect();
    if (rect.width) return toRect(rect);
  }
  if (storedRect && storedRect.width) return storedRect;
  return fallbackLauncherRect();
}

// Build the compact widget's rect from a top-left position and its fixed size.
export function buildCompactRect(position, size) {
  const pos = position || { left: 0, top: 0 };
  return { left: pos.left, top: pos.top, width: size.width, height: size.height };
}

// A CSS transform mapping the source rect's center onto the target rect, scaled to fit.
export function computeDockTransform(source, target) {
  const scale = target.width / source.width;
  const translateX =
    target.left + target.width / 2 - (source.left + source.width / 2);
  const translateY =
    target.top + target.height / 2 - (source.top + source.height / 2);
  return `translate(${translateX}px, ${translateY}px) scale(${scale})`;
}

// Run a callback after the browser has painted the current frame, so a freshly
// applied "start" style commits before the transition target is set.
export function runAfterPaint(callback) {
  requestAnimationFrame(() => requestAnimationFrame(callback));
}